import * as React from 'react';
import leftImageDesk from '../../assets/Img/desktop/5_choose_sx.jpg';
import rightImageDesk from '../../assets/Img/desktop/5_choose_dx.jpg';
import leftImageMob from '../../assets/Img/mobile/5_choose_sx.jpg';
import rightImageMob from '../../assets/Img/mobile/5_choose_dx.jpg';

import { ReactCompareSlider, ReactCompareSliderImage } from 'react-compare-slider';
import { Slider } from '../Slider';
import { isMobile, mediaQueries } from '../../mediaQueries';
import { colors } from '../../colors';
import Sticky from '../sticky/Sticky';
import { CTA } from '../Cta';
import * as Scroll from 'react-scroll';
import { ArrowDown } from '../ArrowDown';
import useResizeAware from 'react-resize-aware';
import { useInView } from 'react-intersection-observer';
import { ArrowNext } from '../ArrowNext';

interface IProps {
    height?: number;
    stickyHeight?: number;
    onNextClickScroll?: string;
    trackingCluster: string;
}
export const Choose = ({ height, stickyHeight, onNextClickScroll, trackingCluster }: IProps) => {

    const isMob = isMobile();
    const isSmallScreen = mediaQueries.isSmallScreen();
    const [isSticky, setIsSticky] = React.useState(false);

    const [isEntered, setIsEntered] = React.useState(false);
    const [isCompleting, setIsCompleting] = React.useState(false);

    const { ref, inView, entry } = useInView({
       
        threshold: [0.4, 0.7],
    });


    React.useEffect(() => {
        // console.info('entry', entry);
        setIsEntered(entry && (entry.intersectionRatio > 0.4 && entry.intersectionRect.top > 0 || entry.boundingClientRect.top < 0))
        setIsCompleting(entry && (entry.intersectionRatio > 0.7 && entry.intersectionRect.top > 0 || entry.boundingClientRect.top < 0))
        // setIsEntered(entry && entry.isIntersecting)
    }, [entry])


    const leftImage = isMob || isSmallScreen ? leftImageMob : leftImageDesk;
    const rightImage = isMob || isSmallScreen ? rightImageMob : rightImageDesk;
    const pageH = height - stickyHeight;

    const [resizeListener, contentHeaderSizes] = useResizeAware();

    const onStickyChange = (v: boolean) => {
        setIsSticky(v);
    }


    const onArrowClick = () => {

        Scroll.scroller.scrollTo('chooose-scroll-content', {
            duration: 1000,
            delay: 50,
            smooth: true,
            offset: - stickyHeight
        });
    }
    const onNextArrowClick = () => {

        Scroll.scroller.scrollTo(onNextClickScroll, {
            duration: 1000,
            delay: 50,
            smooth: true,
        });
    }

    return <div className={`page-container ${isSticky ? "sticky" : "non-sticky"} ${isEntered ? "inside-view" : "outside-view"} ${isCompleting ? "completing-view" : ""}`}>
        <Scroll.Element name="chooose-scroll" />
        <Sticky offsetTop={stickyHeight} zIndex={3} onChange={onStickyChange} >
            <div className="comparer-container" style={{ height: pageH, position: 'relative', zIndex: 5 }}>
                <ReactCompareSlider
                    onlyHandleDraggable={true}
                    handle={<Slider pageH={pageH} />}
                    itemOne={<ReactCompareSliderImage src={leftImage} className="compare-slider-image" style={{ maxHeight: pageH }} alt="Choose" />}
                    itemTwo={<ReactCompareSliderImage src={rightImage} className="compare-slider-image" style={{ maxHeight: pageH }} alt="Choose" />}
                />
            </div>
        </Sticky>
        <div ref={ref} className='page-text-content' style={{ marginTop: -contentHeaderSizes.height + stickyHeight, zIndex: 5, height: pageH }}>

            <div className="block start">
                <div className="centered">
                    {resizeListener}
                    <ArrowDown color="white" onClick={onArrowClick} />
                    <Scroll.Element name="chooose-scroll-content" />
                    <h2 className="upper"> Scegliere Chooose Per scegliere il pianeta. </h2>
                </div>

                <span className="red-line" />

            </div>
            <div className="block ">
                <p>Grazie al progetto Chooose puoi compensare le emissioni di CO2
                della tua auto: inserendo alcune informazioni potrai subito ottenere la
                stima delle tue emissioni e scoprire come compensarle con un contributo. </p>
            </div>
            <div className="block ">
                <CTA gaLabel="choose" trackingCluster={trackingCluster} trackingAction="click_Choose" text={'SCOPRI IL PROGETTO'} href="https://santander-italia.chooose.today/" />
                {/* <p className="small light">Messaggio promozionale. Informazioni europee di base sul credito ai consumatori sul sito www.santanderconsumer.it <br />Salvo approvazione Santander Consumer Bank</p> */}
            </div>
        </div>
        {onNextClickScroll && <ArrowNext onClick={onNextArrowClick} />}

    </div>
}